import { CallbackEvent } from '../../types/sdk';

export class CallbackRegistry {
	private readonly registry: Partial<Record<CallbackEvent, Function>>;

	constructor() {
		this.registry = {};
		this.register = this.register.bind(this);
		this.retrieve = this.retrieve.bind(this);
	}

	register(event: CallbackEvent, callback: Function) {
		this.registry[event] = callback;
	}

	retrieve(event: CallbackEvent) {
		return (data?: any) => {
			const callback = this.registry[event];
			if (callback) callback(data);
		};
	}
}

export const callbackRegistry = new CallbackRegistry();
